import {combineReducers} from "redux";
import favorite from "store/reducer/event/favorite/reducer";
import search from "features/pages/events/reducer";
import single from "features/pages/single-event/reducer";
import like from "store/reducer/event/like/reducer";

export default combineReducers({
    favorite,
    search,
    single,
    like
});